import React from "react";
import { motion } from "framer-motion";
import { RadialBarChart, RadialBar, ResponsiveContainer, PolarAngleAxis } from "recharts";
import { getScoreColorClass, getScoreHex } from "../gradeColors";
import { formatCategoryLabel } from "../categoryLabels";

export default function CategoryScoresChart({ scores = [], title = "Category Performance" }) {
	if (!scores.length) return null;

	const chartData = [...scores]
		.sort((a, b) => b.score - a.score)
		.map((item) => ({
			name: formatCategoryLabel(item.category),
			score: Math.round(item.score ?? item.weighted_score ?? 0),
			fill: getScoreHex(item.score ?? item.weighted_score ?? 0),
			weight: item.weight ?? 0,
		}));

	return (
		<motion.div
			className="category-scores-chart"
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
		>
			<h2 className="category-scores-chart__title">{title}</h2>

			<div className="category-scores-chart__layout">
				<div
					className="category-scores-chart__chart-wrap"
					style={{ height: `${chartData.length * 48}px` }}
				>
					<ResponsiveContainer width="100%" height="100%">
						<RadialBarChart
							cx="50%"
							cy="50%"
							innerRadius="10%"
							outerRadius="90%"
							data={chartData}
							startAngle={90}
							endAngle={-270}
						>
							<PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
							<RadialBar
								background
								dataKey="score"
								cornerRadius={10}
								label={{ position: "insideStart", fill: "#fff", fontSize: 12 }}
							/>
						</RadialBarChart>
					</ResponsiveContainer>
				</div>

				<div className="category-scores-chart__list">
					{chartData.map((item, index) => (
						<motion.div
							key={item.name}
							className="category-scores-chart__row"
							initial={{ opacity: 0, x: 20 }}
							animate={{ opacity: 1, x: 0 }}
							transition={{ delay: index * 0.05 }}
						>
							<div className="category-scores-chart__row-main">
								<div className="category-scores-chart__row-header">
									<span className="category-scores-chart__row-label">{item.name}</span>
									<span className={`category-scores-chart__row-score ${getScoreColorClass(item.score)}`}>
										{item.score}
									</span>
								</div>
								<div className="category-scores-chart__track">
									<motion.div
										className="category-scores-chart__fill"
										initial={{ width: 0 }}
										animate={{ width: `${item.score}%` }}
										transition={{ duration: 0.8, delay: index * 0.05 + 0.2 }}
										style={{ backgroundColor: item.fill }}
									/>
								</div>
							</div>
							<div className="category-scores-chart__weight">
								{(item.weight * 100).toFixed(0)}% weight
							</div>
						</motion.div>
					))}
				</div>
			</div>
		</motion.div>
	);
}
